import { render, staticRenderFns } from "./replaceGoodsDetail.vue?vue&type=template&id=1e70f36b"
import script from "./replaceGoodsDetail.vue?vue&type=script&lang=js"
export * from "./replaceGoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./replaceGoodsDetail.vue?vue&type=style&index=0&id=1e70f36b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports